import { __decorate, __metadata } from "tslib";
import { dispatchEvent, translate } from '@1inch-community/core/lit-utils';
import '@1inch-community/ui-components/card';
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { map as LitMap } from 'lit/directives/map.js';
import { walletAccountCardMoreStyle } from './wallet-account-card-more.style';
let WalletAccountCardMoreElement = class WalletAccountCardMoreElement extends LitElement {
    constructor() {
        super(...arguments);
        this.items = [];
    }
    static { this.tagName = 'inch-wallet-account-card-more'; }
    static { this.styles = [walletAccountCardMoreStyle]; }
    onMenuItemClick(id) {
        dispatchEvent(this, 'menuMoreItemClick', id);
    }
    render() {
        return html `
      <inch-card overlayView>
        ${LitMap(this.items, (item) => html `
            <inch-button
              class="popup-item"
              @click="${() => this.onMenuItemClick(item.id)}"
              type="tertiary-gray"
              fullSize="${true}"
              size="l"
            >
              <div class="popup-item-content-container popup-item-content-container__${item.style}">
                <inch-icon class="popup-item-content-icon" icon="${item.icon}"></inch-icon>
                <span>${translate(item.text)}</span>
              </div>
            </inch-button>
          `)}
      </inch-card>
    `;
    }
};
__decorate([
    property({ type: Array, attribute: false }),
    __metadata("design:type", Array)
], WalletAccountCardMoreElement.prototype, "items", void 0);
WalletAccountCardMoreElement = __decorate([
    customElement(WalletAccountCardMoreElement.tagName)
], WalletAccountCardMoreElement);
export { WalletAccountCardMoreElement };
//# sourceMappingURL=wallet-account-card-more.element.js.map